import bemBlock from '@gik/core/utils/bemBlock';
import { Button, FontIcon } from '@gik/ui';
import React from 'react';
import RelatedArticles from '.';
import { DisableSuggestionsButton, SidebarSection } from '..';
import { useTranslation } from 'react-i18next';
import { translationKeys } from './i18n/en';
import routes from '@gik/core/routes';
import Link from '@/components/Link';
import { openPremiumPageUpgradeModal } from '@gik/inkind-page';

interface IRelatedArticlesSectionProps {
  inkindRouteId: string;
  showDisable?: boolean;
}

export default function RelatedArticlesSection({ inkindRouteId, showDisable = false }: IRelatedArticlesSectionProps) {
  const { t } = useTranslation();
  const bem = bemBlock('related-articles-section');

  function onClickDisable() {
    return openPremiumPageUpgradeModal({
      initiatedOn: 'inkindPage',
      variant: 'hideSuggestions',
      patchInkindRequest: {
        enableSuggestedArticles: false,
      },
    });
  }

  // TODO: extract append to DisableSidebarFeatureButton
  return (
    <SidebarSection
      title={t(translationKeys.title)}
      className={bem()}
      {...((showDisable && {
        append: <DisableSuggestionsButton className={bem('disable-button')} onClick={onClickDisable} />,
      }) ||
        {})}
    >
      <RelatedArticles inkindRouteId={inkindRouteId} />
      <Link href={routes.blog}>
        <Button block prepend={<FontIcon size="lg" name="article" />} className={bem('see-all-button')}>
          {t(translationKeys.seeAllArticles)}
        </Button>
      </Link>
    </SidebarSection>
  );
}
